import React, { useCallback } from 'react'
import { IconButton, Tooltip } from '@material-ui/core'
import { ICON_NAMES } from '../../../../../constants'
import Icon from '../../../../atoms/Icon'
import { useCSV } from '../../../../../hooks'
import { useSyncedTransactions } from './SyncedTransactionsProvider'

export default function SyncedTransactionsExport () {
  const { rows, mergedColumns } = useSyncedTransactions()
  const { downloadCSVFile } = useCSV()

  const handleExport = useCallback(() => {
    const visibleCols = mergedColumns.filter(c => !c.hidden && !c.exclude)
    const headers = visibleCols.map(c => ({ key: c.accessorKey, label: c.displayName }))
    downloadCSVFile({
      data: rows,
      headers,
      fileName: `synced-transactions-${new Date().toISOString().slice(0, 10)}.csv`
    })
  }, [rows, mergedColumns, downloadCSVFile])

  return (
    <Tooltip title='Export Table'>
      <IconButton onClick={handleExport} disabled={!rows.length}>
        <Icon name={ICON_NAMES.download} customSize='22px' />
      </IconButton>
    </Tooltip>
  )
}
